/* eslint-disable no-undef */
import SETTINGS from '../../settings';

const TAG = 'GTAG';

function track(event, data) {
  try {
    gtag('event', event, data);
  } catch (error) {
    // GTAG should not be defined
    setTimeout(() => {
      try {
        gtag('event', event, data);
      } catch (e) {
        console.log(TAG, event, error);
      }
    }, 3000);
  }
}

// Cart rows: item_id is the SKU, the row id is a UUID for editor items.
const cartItems = items => items.map((item, index) => ({
  item_id: item.productId,
  item_name: item.productId,
  index,
  price: item.product?.price,
  quantity: item.quantity,
}));

const Gtag = {
  pageView() {
    track('page_view');
  },

  productView(sku, name, price, currency) {
    track("view_item", {
      currency,
      value: price,
      items: [
        {
          item_id: sku,
          item_name: sku,
          index: 0,
          price,
          quantity: 1,
        }
      ]
    });
  },

  cartItemAdd(sku, name, price, currency) {
    track("add_to_cart", {
      currency,
      value: price,
      items: [
        {
          item_id: sku,
          item_name: sku,
          index: 0,
          price,
          quantity: 1,
        }
      ]
    });
  },

  checkoutInit(price, currency, promoCode, items) {
    track('begin_checkout', {
      currency,
      value: price,
      coupon: promoCode ? promoCode : undefined,
      items: cartItems(items),
    });
  },

  viewCart(price, currency, items) {
    track('view_cart', { currency, value: price, items: cartItems(items) });
  },

  addShippingInfo(price, currency, shippingTier, items) {
    track('add_shipping_info', {
      currency,
      value: price,
      shipping_tier: shippingTier,
      items: cartItems(items),
    });
  },

  removeFromCart(item, context) {
    track('remove_from_cart', {
      currency: item.product?.currency,
      value: (item.product?.price ?? 0) * item.quantity,
      items: cartItems([item]),
      context,
    });
  },

  addPaymentInfo(price, currency, paymentMethod, items) {
    track('add_payment_info', {
      currency,
      value: price,
      payment_method: paymentMethod,
      items: items.map((item, index) => (
        {
          item_id: item.id,
          item_name: item.id,
          index,
          price: item.single,
          quantity: item.quantity,
        }
      ))
    });
  },

  checkoutPayClick(paymentMethod, price, currency) {
    track('checkout_pay_click', { currency, value: price, payment_method: paymentMethod });
  },

  checkoutFieldError(field, type) {
    track('checkout_field_error', { error_field: field, error_type: type });
  },

  expressPayClick(wallet) {
    track('express_pay_click', { wallet });
  },

  paymentFailure(paymentMethod, errorCode) {
    track('checkout_payment_failure', { payment_method: paymentMethod, error_code: errorCode });
  },

  // Custom event with explicit parameters, unlike customEvent's legacy label/category.
  event(action, params) {
    track(action, params);
  },

  giftNoteToggle(selected) {
    track('gift_note_toggle', { gift_selected: selected });
  },

  giftNoteWritten(messageLength) {
    track('gift_note_written', { message_length: messageLength });
  },

  orderSend(price, currency, externalOrderId, promoCode, shipping, items) {
    track("purchase", {
      transaction_id: externalOrderId,
      value: price,
      currency,
      coupon: promoCode ? promoCode : undefined,
      shipping,
      items: items.map((item, index) => (
        {
          item_id: item.id,
          item_name: item.id,
          index,
          price: item.single,
          quantity: item.quantity,
        }
      ))
    });
  },

  customEvent(action, label = undefined, category = undefined, value = undefined) {
    track(action, {
      event_label: label,
      event_category: category,
      value,
    });
  },
};

export default Gtag;
